// extracted by mini-css-extract-plugin
module.exports = {"research":"Research_research__1h1Rf","content":"Research_content__2FOuI","contentInner":"Research_contentInner__NGeSe"};